var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.88,206.61c14.8,0.14,25.1,3.78,33.72,11.58c27.11,24.53,54.12,49.17,81.18,73.76c7.24,6.58,12.05,6.46,18.59-0.93 c34.27-38.7,68.48-77.46,102.7-116.21c32.35-36.63,64.68-73.28,97.02-109.92c14.3-16.2,28.59-32.41,42.89-48.61 c1.21-1.37,2.41-2.76,3.68-4.07c5.83-6.05,13.36-6.89,19.16-2.18c5.96,4.84,6.83,11.9,2.37,19.08 c-52.72,85.1-105.45,170.2-158.17,255.3c-28.2,45.52-56.39,91.04-84.59,136.56c-9.65,15.58-23.18,24.5-41.91,24 c-11.68-0.31-21.84-4.85-29.44-13.67c-11.93-13.85-23.33-28.16-34.89-42.33c-27.96-34.27-55.81-68.61-83.83-102.83 c-21.67-26.46-13.99-62.53,16.31-75.83C35.53,207.75,41.67,206.49,44.88,206.61z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.d087366b55fea8ddc3c2b93fdb7eb5b7.svg";
export { ForwardRef as ReactComponent };